"use strict";

(function (global) {

  /**
   * Навешивает меню на кнопку "Выполнить" для заданий.
   *
   * @function Core.toolBars.job.initPerformButton
   * @param {WebAccess.components.wrappers.toolBar.ToolBarButton} button Кнопка "Выполнить" на ленте тулбара.
   * @param {array<object>} opt_choices Перечень вариантов выполнения задания.
   * @since 5.2.0.1500
   */
  global.initPerformButton = function (button, opt_choices) {
    var choices;

    if (opt_choices && opt_choices.length) {
      choices = opt_choices;
    } else if (typeof fillJobChoiceText === 'function') {
      choices = fillJobChoiceText();
    } else {
      return ;
    }
    
    var menu_items = [];
    for (var i = 0; i < choices.length; ++i) {
      menu_items.push({
        text: choices[i].DisplayName,
        onClick: (function (performResult) { // замыкание для корректной передачи choices[i], т.к. переменная i меняется в цикле
          return function () {
            global.performResult(performResult);
          };
        })(choices[i])
      });
    }
    var additionalSettings = {
      onShow: function () {
        button.select();
      },
      onHide: function () {
        button.unSelect();
      }
    };
    var menu = new ContextMenu(menu_items, {
      shiftX: 0,
      shiftY: 38,
      width: "auto",
      cssClass: "performs-context-menu",
      onShow: function () {
        if (!button.isEnabled()) {
          ContextMenu.hide();
          return false;
        }
        additionalSettings.onShow();
      },
      onHide: function () {
        additionalSettings.onHide();
      }
    });
    // Добавляем контекстное меню для кнопки. Добавление возможно только через jQuery элемент,
    // т.к. для контекстного меню используются функции jQuery.
    var jButton = $(format('div[name={0}]', button.name));
    jButton.contextMenu(menu);

  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  // Проверяет наличие параметров ТМ.
  function ExecuteBeforeQueryParamsEvent(performResultCode) {
    var jActiveText;
    if (WA.isMobile()) {
      jActiveText = $('.textarea');
    } else {
      jActiveText = $('.Job_Edit_Text_Area_Control').filter('textarea');
    }
    var activeText = jActiveText.val();

    return WA.SRV.call('/Job.asmx/ExecuteBeforeQueryParamsEvent', {
      JobID: WA.CR.ID,
      PerformResultName: performResultCode,
      ActiveText: (activeText) ? activeText : ""
    }).done(function (r) {
      jActiveText.val(r.newActiveText);
    });
  }

  //Выполнение задания с результатами выполнения и запрашиваемыми параметрами.
  function JobWFSetResult(el) {
    UnbindBeforeUnload();
    $("#__RESULT_VAR").val(el.id);
    // Вызвать событие "До запроса параметров", если по ТМ и означено.
    WebAccess.Job.fireAll("ParamAsking", function () { DoAction('__POSTBACK_ACTION=AcceptWfVar', true) });
  }

  //Выполнение задания с результатами выполнения без запрашиваемых параметров.
  function JobWFParams(el) {
    UnbindBeforeUnload();
    $("#__RESULT_VAR").val(el.id);

    WebAccess.Job.fireAll("ParamAsking", function () {
      if (GetParamInURL("op") != "") {
        DoAction('__POSTBACK_ACTION=ShowParams', true, RemoveParamInURL($('form:first').attr('action'), 'op'));
      } else {
        DoAction('__POSTBACK_ACTION=ShowParams', true);
      }
    });
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


  /**
   * Действие на кнопку "Выполнить" для заданий.
   * @since 5.2.0.1500
   * @function Core.toolBars.job.perform
   */
  global.perform = (event) => {
    function _checkAttachmentAccessRights(callback) {
      WA.SRV.call('Job.asmx/CheckAttachmentsRights', {
        JobId: WA.CR.ID,
      }).done((maxRights) => {
        function _setAccessRights(accessRights) {
          WA.SRV.call('Job.asmx/SetAttachmentsRights', {
            JobID: WA.CR.ID,
            Rights: accessRights,
          }).done(() => {
            callback();
          });
        }

        if (maxRights !== 'NoAccess') {
          Core.customWorks.showAccessRightsDialog(maxRights, {
            View: () => _setAccessRights(ACCESS_RIGHTS.VIEW),
            Change: () => _setAccessRights(ACCESS_RIGHTS.CHANGE),
            Full: () => _setAccessRights(ACCESS_RIGHTS.FULL),
            Ignore: () => callback(),
          });
        } else {
          callback();
        }
      });
    }

    if (!CheckIsWf()) {
      // Задание не по ТМ.
      ConfirmDialogNew(L("CONFIRM_JOB_PERFORM"), () => {
        _checkAttachmentAccessRights(() => {
          UnbindBeforeUnload();
          DoAction('__POSTBACK_ACTION=ApproveWf', true);
        });
      });
    } else {
      if (ResultNotEmpty()) {
        // Есть результаты выполнения.
        DoItAdditionalAction(event);
      } else {
        ConfirmDialogNew(L("CONFIRM_JOB_PERFORM"), () => {
          _checkAttachmentAccessRights(() => {
            WebAccess.Job.fireAll("Perform", () => {
              // Нет результатов выполнения.
              ExecuteBeforeQueryParamsEvent('').done((result) => {
                if (result.hasAskableParams) {
                  // Есть запрашиваемые параметры.
                  JobWFParamsEmptyResult();
                } else {
                  // Нет запрашиваемых параметров.
                  JobWFSetEmptyResult();
                }
              });
            });
          });
        });
      }
    }
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  //Выполнение задания без результатов выполнения, но с запрашиваемыми параметрами.
  function JobWFParamsEmptyResult() {
    UnbindBeforeUnload();
    WebAccess.Job.fireAll("ParamAsking", function () {
      if (GetParamInURL("op") != "") {
        DoAction('__POSTBACK_ACTION=ShowParams', true, RemoveParamInURL($('form:first').attr('action'), 'op'));
      } else {
        DoAction('__POSTBACK_ACTION=ShowParams', true);
      }
    });
  }

  //Выполнение задания без результатов выполнения и без запрашиваемыми параметрами.
  function JobWFSetEmptyResult() {
    UnbindBeforeUnload();
    // Вызвать событие "До запроса параметров", если по ТМ и означено.
    WebAccess.Job.fireAll("ParamAsking", function () { DoAction('__POSTBACK_ACTION=AcceptWfEmpty', true); });
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Кнопка "Выполнить с результатом выполнения" для заданий.
   * @since 5.2.0.1500
   * @function Core.toolBars.job.performResult
   */
  global.performResult = function (performResult) {
    ConfirmDialogNew(L("CONFIRM_JOB_PERFORM_RESULT", performResult.DisplayName), function () {

      WebAccess.Job.fireAll("Perform", function () {
        ExecuteBeforeQueryParamsEvent(performResult.Name).done(function (r) {
          if (r.hasAskableParams) {
            JobWFParams({ id: performResult.Index });
          } else {
            JobWFSetResult({ id: performResult.Index });
          }
        });
      }, performResult);

    });
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Кнопка "Выполнить с результатом выполнения" для заданий.
   * @since 5.2.0.1500
   * @function Core.toolBars.job.performResultInMobile
   */
  global.performResultInMobile = function (resultEl) {
    global.performResult({
      Name: $(resultEl).text(),
      Index: resultEl.id
    });
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  // Отображение вариантов выполнения.
  function DoItAdditionalAction() {
    var isMobile = $('html').hasClass('mobile');
    if (isMobile) {
      var m = $("table.AddActions");
      m.find('td').empty().html(fillJobChoiceText());
      m.show();
    } else {
      // Тут нет, т.к. в основной версии кнопка переопределяется и при нажатии выводится контекстное меню.
    }
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


})(window.Core.toolBars.job);